import Vue from 'vue'
import Router from 'vue-router'
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import jwt_decode from "jwt-decode";

import Home from '@/templates/home/Home'
//import Onboarding from '@/templates/home/Onboarding'
//import Analyze from '@/templates/analyze/Analyze'
import Analyze from '@/templates/analyze/AnalyzePage'
import Overview from '@/templates/analyze/Overview'
import Overviewv2 from '@/templates/analyze/Overview-v2'
import Attribution from '@/templates/analyze/Attribution'
import Engagement from '@/templates/analyze/Engagement'
import FunnelAnalysis from '@/templates/analyze/FunnelAnalysis'
import AnalyseFunnels from '@/templates/analyze/Funnels'
import Acquisition from '@/templates/analyze/Acquisition'
import guestOverview from '@/templates/analyze/guestOverview'

//LEADS
import Leads_main from '@/templates/leads/Leads_main'
import Leads from '@/templates/leads/Leads'
import LeadConversions from '@/templates/leads/LeadConversions'
import Lead from '@/templates/leads/Lead'
import Timeline from '@/templates/leads/Timeline'
import Clicks from '@/templates/leads/Clicks'
import Clicksv2 from '@/templates/leads/Clicksv2'
import Clicksv3 from '@/templates/leads/Clicksv3'
import Orders from '@/templates/leads/Orders'
import Events from '@/templates/leads/Events'

//SETUP
import Onboarding from '@/templates/setup/Onboarding.vue';
import Setup from '@/templates/setup/Setup.vue';
import Conversions from '@/templates/setup/Conversions.vue';
//Milestones was changed to Automations
import Automations from '@/templates/setup/Automations.vue';
import Watchers from '@/templates/setup/Watchers.vue';
import Tracking from '@/templates/setup/Tracking.vue';
import API from '@/templates/setup/api.vue';
import Instructions from '@/templates/setup/Instructions.vue';
import Integrations from '@/templates/setup/Integrations.vue';
import Integration from '@/templates/setup/Integration.vue';
import Funnels from '@/templates/setup/Funnels.vue';

import Academy from '@/templates/Academy/Academy.vue';

import ACADEMY_sales_offer from '@/templates/Academy/courses/01-Offer/course.vue';

import ACADEMY_business_accelerator from '@/templates/Academy/courses/business-accelerator/business-accelerator.vue';
import ACADEMY_business_accelerator_01_offer from '@/templates/Academy/courses/business-accelerator/01-offer.vue';
import ACADEMY_business_accelerator_02_sales_page from '@/templates/Academy/courses/business-accelerator/02-sales-page.vue';
import ACADEMY_business_accelerator_03_checkout from '@/templates/Academy/courses/business-accelerator/03-checkout.vue';
import ACADEMY_business_accelerator_04 from '@/templates/Academy/courses/business-accelerator/04-backend.vue';
import ACADEMY_business_accelerator_05 from '@/templates/Academy/courses/business-accelerator/05.vue';
import ACADEMY_business_accelerator_06 from '@/templates/Academy/courses/business-accelerator/06.vue';

import ACADEMY_facebookads from '@/templates/Academy/courses/facebook-ads-masterclass/index.vue';
import ACADEMY_facebookads_01 from '@/templates/Academy/courses/facebook-ads-masterclass/01.vue';
import ACADEMY_facebookads_02 from '@/templates/Academy/courses/facebook-ads-masterclass/02.vue';
import ACADEMY_facebookads_03 from '@/templates/Academy/courses/facebook-ads-masterclass/03.vue';
import ACADEMY_facebookads_04 from '@/templates/Academy/courses/facebook-ads-masterclass/04.vue';
import ACADEMY_facebookads_05 from '@/templates/Academy/courses/facebook-ads-masterclass/05.vue';

import ACADEMY_copywriting from '@/templates/Academy/courses/copywriting-masterclass/index.vue';
import ACADEMY_copywriting_01 from '@/templates/Academy/courses/copywriting-masterclass/01.vue';
import ACADEMY_copywriting_02 from '@/templates/Academy/courses/copywriting-masterclass/02.vue';
import ACADEMY_copywriting_03 from '@/templates/Academy/courses/copywriting-masterclass/03.vue';
import ACADEMY_copywriting_04 from '@/templates/Academy/courses/copywriting-masterclass/04.vue';
import ACADEMY_copywriting_05 from '@/templates/Academy/courses/copywriting-masterclass/05.vue';
import ACADEMY_copywriting_06 from '@/templates/Academy/courses/copywriting-masterclass/06.vue';

//INTEGRATION PAGES
import MAILCHIMP from '@/templates/setup/integrations/MAILCHIMP.vue';
import GETRESPONSE from '@/templates/setup/integrations/GETRESPONSE.vue';
import ACTIVECAMPAIGN from '@/templates/setup/integrations/ACTIVECAMPAIGN.vue';
import WOOCOMMERCE from '@/templates/setup/integrations/WOOCOMMERCE.vue';
import FACEBOOK from '@/templates/setup/integrations/FACEBOOK.vue';
import GOOGLE_ADWORDS from '@/templates/setup/integrations/GOOGLE_ADWORDS.vue';
import OPENCART from '@/templates/setup/integrations/OPENCART.vue';
import SHOPIFY from '@/templates/setup/integrations/SHOPIFY_CUSTOM.vue';
import CLICKFUNNELS from '@/templates/setup/integrations/CLICKFUNNELS.vue';
import STRIPE from '@/templates/setup/integrations/STRIPE.vue';
import TIKTOK from '@/templates/setup/integrations/TIKTOK.vue';
import SENDGRID from '@/templates/setup/integrations/SENDGRID.vue';
import DRIP from '@/templates/setup/integrations/DRIP.vue';
import ZAPIER from '@/templates/setup/integrations/ZAPIER.vue';

//SETTINGS
import Settings from '@/templates/settings/Settings.vue';
import Account from '@/templates/settings/Account.vue';
import Pricing from '@/templates/settings/Pricing.vue';
import Billing from '@/templates/settings/Billing.vue';
import Users from '@/templates/settings/Users.vue';


//ADMIN
import Admin from '@/templates/admin/Admin.vue';
import Organizations from '@/templates/admin/Organizations'
import Organization from '@/templates/admin/Organization'
import OrganizationDetails from '@/templates/admin/OrganizationDetails'
import OrgEvents from '@/templates/admin/OrgEvents'
import OrgUsers from '@/templates/admin/OrgUsers'

import Login from '@/templates/auth/Login'
import ResetPassword from '@/templates/auth/resetPassword'
import Logout from '@/templates/auth/Logout'
import CreateAccount from '@/templates/auth/CreateAccount'
import ThankYou from '@/templates/auth/ThankYou'

Vue.use(Router)

export default new Router({
    history: true,
    mode: 'history',
    base: '/app',
    routes: [
        {
            path: '/',
            //redirect: '/overview'
            redirect: '/welcome'

        },
        {
            //path: ':APPKEY/dashboard',
            path: '/dashboard',
            name: 'Home',
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            //path: ':APPKEY/onboarding',
            path: '/welcome',
            name: 'Onboarding',
            component: Onboarding,
            meta: {
                requiresAuth: true
            }
        },

        {
            path: '/overview',
            name: 'Overview',
            component: Overviewv2,
            meta: {
                requiresAuth: true
            }
        },

        {
            path: '/stats',
            name: 'guestOverview',
            component: guestOverview,
            meta: {
                guest: true,
                requiresAuth: false
            }
        },

        {
            path: '/analyze',
            name: 'Analyze',
            redirect: '/analyze/attribution',
            component: Analyze,
            meta: {
                requiresAuth: true
            },
            children:[
                /*
                {
                    path: 'overview',
                    name: 'Overview',
                    component: Overviewv2,
                    meta: {
                        requiresAuth: true
                    }
                },
                */
                {
                    path: 'engagement',
                    name: 'Engagement',
                    component: Engagement,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'attribution',
                    name: 'Attribution',
                    component: Attribution,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'funnel-analysis',
                    name: 'FunnelAnalysis',
                    component: FunnelAnalysis,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'funnels',
                    name: 'AnalyseFunnels',
                    component: AnalyseFunnels,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'acquisition',
                    name: 'Acquisition',
                    component: Acquisition,
                    meta: {
                        requiresAuth: true
                    }
                },
            ]
        },
        {
            path: '/analyze-v2',
            name: 'Attribution',
            component: Attribution,
            meta: {
                requiresAuth: true
            }
        },



        //LEADS START
        {
            path: '/customers',
            name: 'Leads_main',
            redirect: '/customers/leads',
            component: Leads_main,
            props: true,
            meta: {
                requiresAuth: true,
                //isAdmin: true
            },
            children: [
                {
                    //path: ':APPKEY/onboarding',
                    path: 'leads',
                    name: 'Leads',
                    component: Leads,
                    props: true,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    }
                },
                {
                    path: 'conversions',
                    name: 'LeadConversions',
                    component: LeadConversions,
                    props: true,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    }
                },
            ]
        },


        {
            path: '/leads/:ID',
            name: 'Lead',
            redirect: '/leads/:ID/timeline',
            component: Lead,
            props: true,
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: 'timeline',
                    name: 'Timeline',
                    component: Timeline,
                    props: true,
                    meta: {
                        requiresAuth: true
                    },
                },
                {
                    path: 'clicks',
                    name: 'Clicks',
                    component: Clicks,
                    props: true,
                    meta: {
                        requiresAuth: true
                    },
                },
                {
                    path: 'clicks-v2',
                    name: 'Clicksv2',
                    component: Clicksv2,
                    props: true,
                    meta: {
                        requiresAuth: true
                    },
                },
                {
                    path: 'clicks-v3',
                    name: 'Clicksv3',
                    component: Clicksv3,
                    props: true,
                    meta: {
                        requiresAuth: true
                    },
                },
                {
                    path: 'orders',
                    name: 'Orders',
                    component: Orders,
                    props: true,
                    meta: {
                        requiresAuth: true
                    },
                },
                {
                    path: 'events',
                    name: 'Events',
                    component: Events,
                    props: true,
                    meta: {
                        requiresAuth: true,
                        //isAdmin: true
                    },
                },
            ]
        },
        //LEADS END
        //SETUP START
        {
            path: '/setup',
            name: 'Setup',
            redirect: '/setup/set-conversions',
            component: Setup,
            meta: {
                requiresAuth: true
            },
            children: [
                {
                    path: 'set-conversions',
                    name: 'Conversions',
                    component: Conversions,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    }
                },
                {
                    path: 'automations',
                    name: 'Automations',
                    component: Automations,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    }
                },
                {
                    path: 'watchers',
                    name: 'Watchers',
                    component: Watchers,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    }
                },
                {
                    path: 'tracking-script',
                    name: 'Tracking',
                    component: Tracking,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    }
                },
                {
                    path: 'api-setup',
                    name: 'API',
                    component: API,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    }
                },
                {
                    path: 'instructions',
                    name: 'Instructions',
                    component: Instructions,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    }
                },
                {
                    path: 'integrations',
                    name: 'Integrations',
                    component: Integrations,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    },
                    children: [

                    ]
                },
                {
                    path: 'integrations/:APP',
                    name: 'Integration',
                    component: Integration,
                    props: true,
                    meta: {
                        requiresAuth: true
                        //isAdmin: true
                    },
                    children: [

                    ]
                },
                //INTEGRATIONS
                { path: 'integrations/mailchimp/:ID', name: 'MAILCHIMP', component: MAILCHIMP, props: true, },
                { path: 'integrations/activecampaign/:ID', name: 'ACTIVECAMPAIGN', component: ACTIVECAMPAIGN, props: true, },
                { path: 'integrations/getresponse/:ID', name: 'GETRESPONSE', component: GETRESPONSE, props: true, },
                { path: 'integrations/woocommerce/:ID', name: 'WOOCOMMERCE', component: WOOCOMMERCE, props: true, },
                { path: 'integrations/facebook/:ID', name: 'FACEBOOK', component: FACEBOOK, props: true, },
                { path: 'integrations/google-adwords/:ID', name: 'ADWORDS', component: GOOGLE_ADWORDS, props: true, },
                { path: 'integrations/opencart/:ID', name: 'OPENCART', component: OPENCART, props: true, },
                { path: 'integrations/shopify/:ID', name: 'SHOPIFY', component: SHOPIFY, props: true, },
                { path: 'integrations/clickfunnels/:ID', name: 'CLICKFUNNELS', component: CLICKFUNNELS, props: true, },
                { path: 'integrations/stripe/:ID', name: 'STRIPE', component: STRIPE, props: true, },
                { path: 'integrations/tiktok/:ID', name: 'TIKTOK', component: TIKTOK, props: true, },
                { path: 'integrations/sendgrid/:ID', name: 'SENDGRID', component: SENDGRID, props: true, },
                { path: 'integrations/drip/:ID', name: 'DRIP', component: DRIP, props: true, },
                { path: 'integrations/zapier/:ID', name: 'ZAPIER', component: ZAPIER, props: true, },
                //INTEGRATIONS

            ]
        },

        {
            path: '/academy',
            name: 'Academy',
            component: Academy,
            meta: {
                requiresAuth: true
            },
            children: [
            ]
        },
        { path: '/academy/perfect-sales-offer', name: 'Craft the Perfect Sales Offer', component: ACADEMY_sales_offer, props: true },

        //BUSINESS ACCELERATOR
        { path: '/academy/business-accelerator', name: 'Business Accelerator', component: ACADEMY_business_accelerator, props: true },
        { path: '/academy/business-accelerator/1', name: 'Business Accelerator - Offer', component: ACADEMY_business_accelerator_01_offer, props: true },
        { path: '/academy/business-accelerator/2', name: 'Business Accelerator - Sales Page', component: ACADEMY_business_accelerator_02_sales_page, props: true },
        { path: '/academy/business-accelerator/3', name: 'Business Accelerator - Checkout', component: ACADEMY_business_accelerator_03_checkout, props: true },
        { path: '/academy/business-accelerator/4', name: 'Business Accelerator - Backend', component: ACADEMY_business_accelerator_04, props: true },
        { path: '/academy/business-accelerator/5', name: 'Business Accelerator - Metrics', component: ACADEMY_business_accelerator_05, props: true },
        { path: '/academy/business-accelerator/6', name: 'Business Accelerator - Optimizations', component: ACADEMY_business_accelerator_06, props: true },
        //BUSINESS ACCELERATOR

        //COPYWRITING MASTERCLASS
        { path: '/academy/copywriting-masterclass', name: 'Copywriting Masterclass', component: ACADEMY_copywriting, props: true },
        { path: '/academy/copywriting-masterclass/1', name: 'Copywriting Masterclass 1', component: ACADEMY_copywriting_01, props: true },
        { path: '/academy/copywriting-masterclass/2', name: 'Copywriting Masterclass 2', component: ACADEMY_copywriting_02, props: true },
        { path: '/academy/copywriting-masterclass/3', name: 'Copywriting Masterclass 3', component: ACADEMY_copywriting_03, props: true },
        { path: '/academy/copywriting-masterclass/4', name: 'Copywriting Masterclass 4', component: ACADEMY_copywriting_04, props: true },
        { path: '/academy/copywriting-masterclass/5', name: 'Copywriting Masterclass 5', component: ACADEMY_copywriting_05, props: true },
        { path: '/academy/copywriting-masterclass/6', name: 'Copywriting Masterclass 6', component: ACADEMY_copywriting_06, props: true },
        //COPYWRITING MASTERCLASS

        //FACEBOOK ADS MASTERCLASS
        { path: '/academy/facebook-ads-masterclass', name: 'Facebook Ads Masterclass', component: ACADEMY_facebookads, props: true },
        { path: '/academy/facebook-ads-masterclass/1', name: 'Facebook Ads Masterclass 1', component: ACADEMY_facebookads_01, props: true },
        { path: '/academy/facebook-ads-masterclass/2', name: 'Facebook Ads Masterclass 2', component: ACADEMY_facebookads_02, props: true },
        { path: '/academy/facebook-ads-masterclass/3', name: 'Facebook Ads Masterclass 3', component: ACADEMY_facebookads_03, props: true },
        { path: '/academy/facebook-ads-masterclass/4', name: 'Facebook Ads Masterclass 4', component: ACADEMY_facebookads_04, props: true },
        { path: '/academy/facebook-ads-masterclass/5', name: 'Facebook Ads Masterclass 5', component: ACADEMY_facebookads_05, props: true },
        //{ path: '/academy/facebook-ads-masterclass/6', name: 'Facebook Ads Masterclass 6', component: ACADEMY_facebookads_06, props: true },

        //FACEBOOK ADS MASTERCLASS

        //SETTINGS START
        {
            path: '/settings',
            name: 'Settings',
            redirect: '/settings/account',
            component: Settings,
            meta: {
                requiresAuth: true,
                //isAdmin: true
            },
            children: [
                {
                    path: 'account',
                    name: 'Account',
                    component: Account,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'pricing',
                    name: 'Pricing',
                    component: Pricing,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'billing',
                    name: 'Billing',
                    component: Billing,
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                    },
                    beforeEnter: (to, from, next) => {
                        //let user = jwt_decode(Cookies.get('user-token')).data
                        let user = jwt_decode(Cookies.get('user-token')).data
                        //console.log( user )

                        if ( Cookies.get('user') && user.role <= 7 ){
                            next();
                        } else {
                            next('/');
                        }

                    }
                },
                {
                    path: 'users',
                    name: 'Users',
                    component: Users,
                    meta: {
                        requiresAuth: true,
                        requiresAdmin: true,
                    },
                    beforeEnter: (to, from, next) => {
                        let user = jwt_decode(Cookies.get('user-token')).data
                        //console.log( user )

                        if ( Cookies.get('user') && user.role <= 2 ){
                            next();
                        } else {
                            next('/');
                        }

                    }
                },

            ]
        },
        //SETTINGS END

        //ADMIN START
        {
            path: '/admin',
            name: 'Admin',
            redirect: '/admin/organizations',
            component: Admin,
            meta: {
                requiresAuth: true,
                //isAdmin: true,
                requiresSuperadmin: true
            },
            beforeEnter: (to, from, next) => {
                let user = jwt_decode(Cookies.get('user-token')).data
                //console.log( user )

                if ( Cookies.get('user') && user.role == 0 ){
                    next();
                } else {
                    next('/');
                }

            },
            children: [
                {
                    path: 'organizations',
                    name: 'Organizations',
                    component: Organizations,
                    props: true,
                    meta: {
                        requiresAuth: true,
                        requiresSuperadmin: true
                    },
                    beforeEnter: (to, from, next) => {
                        let user = jwt_decode(Cookies.get('user-token')).data
                        //console.log( user )

                        if ( Cookies.get('user') && user.role == 0 ){
                            next();
                        } else {
                            next('/');
                        }

                    }
                },
                {
                    path: 'organizations/:ID',
                    name: 'Organization',
                    redirect: '/admin/organizations/:ID/org-info',
                    component: Organization,
                    props: true,
                    meta: {
                        requiresAuth: true,
                        requiresSuperadmin: true
                    },
                    beforeEnter: (to, from, next) => {
                        let user = jwt_decode(Cookies.get('user-token')).data
                        //console.log( user )

                        if ( Cookies.get('user') && user.role == 0 ){
                            next();
                        } else {
                            next('/');
                        }

                    },
                    children:[
                        {
                            path: 'org-info',
                            name: 'OrganizationDetails',
                            component: OrganizationDetails,
                            props: true,
                            meta: {
                                requiresAuth: true,
                                requiresSuperadmin: true
                            },
                            beforeEnter: (to, from, next) => {
                                let user = jwt_decode(Cookies.get('user-token')).data
                                //console.log( user )

                                if ( Cookies.get('user') && user.role == 0 ){
                                    next();
                                } else {
                                    next('/');
                                }

                            }
                        },
                        {
                            path: 'org-leads',
                            name: 'OrgLeads',
                            component: Leads,
                            props: true,
                            meta: {
                                requiresAuth: true,
                                requiresSuperadmin: true
                            },
                            beforeEnter: (to, from, next) => {
                                let user = jwt_decode(Cookies.get('user-token')).data
                                //console.log( user )

                                if ( Cookies.get('user') && user.role == 0 ){
                                    next();
                                } else {
                                    next('/');
                                }

                            }
                        },
                        {
                            path: 'org-events',
                            name: 'OrgEvents',
                            component: OrgEvents,
                            props: true,
                            meta: {
                                requiresAuth: true,
                                requiresSuperadmin: true
                            },
                            beforeEnter: (to, from, next) => {
                                let user = jwt_decode(Cookies.get('user-token')).data
                                //console.log( user )

                                if ( Cookies.get('user') && user.role == 0 ){
                                    next();
                                } else {
                                    next('/');
                                }

                            }
                        },
                        {
                            path: 'org-users',
                            name: 'OrgUsers',
                            component: OrgUsers,
                            props: true,
                            meta: {
                                requiresAuth: true,
                                requiresSuperadmin: true
                            },
                            beforeEnter: (to, from, next) => {
                                let user = jwt_decode(Cookies.get('user-token')).data
                                //console.log( user )

                                if ( Cookies.get('user') && user.role == 0 ){
                                    next();
                                } else {
                                    next('/');
                                }

                            }
                        },
                    ]
                },

            ]
        },
        //ADMIN END

        {
            path: '/logout',
            name: 'Logout',
            component: Logout,
            meta: {
                guest: false
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                guest: false
            }
        },
        {
            path: '/password-reset',
            name: 'ResetPassword',
            component: ResetPassword,
            meta: {
                guest: false
            }
        },
        /*
        {
            path: '/create-account',
            name: 'CreateAccount',
            component: CreateAccount,
            meta: {
                guest: false
            }
        },
        */

        {
            path: '/thank-you',
            name: 'ThankYou',
            component: ThankYou,
            meta: {
                guest: false
            }
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js